import React from "react";
import NumberFormat from "react-number-format";
import CurrencyDisplay from "../../shared/currency-display";
import Makeup from "./makeup";

function Makeups(props) {
  const {
    budget,
    onChangeMakeupBuget,
    onChangeMakeupDays,
    showHideMakeups,
    makeupsVisible,
    readOnly,
    filmId,
    saving
  } = props;

  return (
    <div>
      <div className="columns subtitle is-4 mt-1">
        <div className="column">
          <h4
            className="subtitle is-4 pointer"
            onClick={() => showHideMakeups(!makeupsVisible)}>
            <button className="button is-text is-small">
              {!makeupsVisible && <i className="material-icons">add</i>}
              {makeupsVisible && <i className="material-icons">remove</i>}
            </button>
            Makeup
          </h4>
        </div>
        <div className="column budget-header-number">
          <CurrencyDisplay
            value={budget.makeupsTotal}
          />
        </div>
      </div>
      {makeupsVisible && (
        <>
          <table className="table budget-table">
            <thead>
              <tr>
                <th>Name</th>
                <th className="budget-days-column">Days</th>
                <th className="budget-daily-rate-column">Budget</th>
                <th className="has-text-centered">Quantity</th>
                <th className="has-text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {(budget?.makeups || []).map((makeup, i) => {
                return (
                  <Makeup
                    key={i}
                    makeup={makeup}
                    onChangeMakeupBuget={onChangeMakeupBuget}
                    onChangeMakeupDays={onChangeMakeupDays}
                    maxDays={budget.days}
                    totalScenes={budget.totalScenes}
                    hasShootingDays={budget.hasShootingDays}
                    readOnly={readOnly}
                    filmId={filmId}
                    saving={saving}
                  />
                );
              })}
              <tr>
                <td colSpan={4}></td>
                <td className="has-text-right">
                  <CurrencyDisplay
                    value={budget.makeupsTotal}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}

export default Makeups;
